/**
 * @fileoverview Optional per-page table of contents.
 *
 * Driven by the `toc` tag on the page's OWN index event, not by the theme. A
 * table of contents is a property of this page's structure; a theme is a look
 * shared by many pages, and mixing the two makes editing a theme silently
 * restructure documents.
 */

export interface Heading {
  id: string;
  text: string;
  level: number;
}

export function TableOfContents({ headings }: { headings: Heading[] }) {
  // A page with one heading has no structure worth navigating, and a bar
  // labelled "Contents" over a single entry is noise.
  if (headings.length < 2) return null;

  return (
    <nav className="page-toc" aria-label="Table of contents">
      <h2 className="page-toc-title">Contents</h2>
      <ul>
        {headings.map((h) => (
          <li key={h.id} data-level={h.level}>
            <a href={`#${h.id}`}>{h.text}</a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
